import { render, staticRenderFns } from "./ModalSerial.vue?vue&type=template&id=5bba5b96&"
import script from "./ModalSerial.vue?vue&type=script&lang=js&"
export * from "./ModalSerial.vue?vue&type=script&lang=js&"
import style0 from "./ModalSerial.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ModalSerial.vue?vue&type=style&index=1&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports